import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getDifficulty } from '../../../redux/Settings/selectors';
import {
  getGameDifficulty,
  allCurrentPhaseGoalsDone,
  getPlayedClass,
} from '../../../redux/Game/selectors';
import BaseContainer from '../../baseContainer';
import InfoField from '../../baseComponents/InfoField';
import PhaseGoals from './PhaseGoals';
import BaseButton from '../../baseButton';
import { GameActions } from '../../../redux/Game';
import { UserActions } from '../../../redux/User';

const PhaseContainer = () => {
  const dispatch = useDispatch();
  const {
    game: { currentPhase, controlledPlayer },
    user: { sessionToken },
  } = useSelector((state) => state);
  const difficulty = useSelector((state) => getDifficulty(state));
  const gameDifficulty = useSelector((state) => getGameDifficulty(state));
  const playedClass = useSelector((state) => getPlayedClass(state));
  const allDone = useSelector((state) => allCurrentPhaseGoalsDone(state));

  return (
    <BaseContainer flexDirection="column">
      <InfoField title="Playing on" info={playedClass.displayName} />
      <InfoField title="Roguelite difficulty" info={difficulty} />
      <InfoField title="Phase" info={currentPhase} size="L" />
      <InfoField title="Game difficulty" info={gameDifficulty} />
      <PhaseGoals />
      {Number(controlledPlayer) === 0 && (
        <BaseButton
          onClick={() => dispatch(GameActions.nextPhase())}
          alt="Start the game and roll some rules!"
          size="18"
          text="Next Phase"
          disabled={!allDone}
        />
      )}
      {Number(controlledPlayer) !== 0 && (
        <BaseButton
          onClick={() => dispatch(UserActions.loadSession(sessionToken))}
          alt=""
          size="18"
          text="Refresh"
        />
      )}
    </BaseContainer>
  );
};

export default PhaseContainer;
